import React, { Component } from 'react';
import config from '../Config/config';
import { Mixpanel } from '../Config/mixpanel';

export const Context = React.createContext();

export class ContextProvider extends Component {
	constructor() {
		super();

		this.state = this.getInitialState();
		this.state.token = localStorage.getItem('token');

		this.actions = {
			login: (username, password) => {
				this.login(username, password);
			},
			printState: () => {
				console.log(this.state);
			},
			getUserProfile: () => {
				this.getUserProfile();
			},
			saveUserProfile: () => {
				this.saveUserProfile();
			},
			logout: () => {
				this.logout();
			},
			updateUserProfile: (value) => {
				this.updateUserProfile(value);
			},
			getAdvertiserCampaigns: () => {
				this.getAdvertiserCampaigns();
			},
			createAdvertiserCampaign: (campaign, done) => {
				this.createAdvertiserCampaign(campaign, done);
			},
			updateAdvertiserCampaignPost: (campaignId, postId, updateQuery) => {
				this.updateAdvertiserCampaignPost(campaignId, postId, updateQuery);
			},
			updateAdvertiserCampaign: (campaignId, updateQuery) => {
				this.updateAdvertiserCampaign(campaignId, updateQuery);
			},
			approveAdvertiserCampaignPosts: (campaignId, done) => {
				this.approveAdvertiserCampaignPosts(campaignId, done);
			},
			addStripeSource: (source, done) => {
				this.addStripeSource(source, done);
			},
			setState: (state) => {
				this.setState(state);
			},
			getAdvertiserCampaignsMagicLink: (magicLink, done) => {
				this.getAdvertiserCampaignsMagicLink(magicLink, done);
			},
			patchAdvertiserCampaignsMagicLink: (magicLink, statusChanges, done) => {
				this.patchAdvertiserCampaignsMagicLink(magicLink, statusChanges, done);
			}
		};
	}

	getInitialState = () => {
		const initialState = {
			loading: false,
			user: null,
			token: null,
			error: null,
			campaigns: [],
			globalMessage: null
		};
		return initialState;
	}

	logout() {
		console.log('Thanks, bye!');
		localStorage.clear();
		Mixpanel.track('Logout');
		Mixpanel.reset();
		this.setState(this.getInitialState());
	}

	getUserProfile() {
		this.setState({
			loading: true,
			error: null
		});
		if (this.state.token) {
			fetch(`${config.URL}/user`, {
				'headers': config.HEADERS(this.state.token),
				'method': "GET"
			})
				.then((res) => {
					if (res.status === 200) {
						return res.json()
					}
					if (res.status === 401) {
						this.logout();
						return;
					}
					throw res.error;
				})
				.then((res) => {
					this.setState({
						"loading": false,
						"user": res
					});
					Mixpanel.identify(res._id);
					Mixpanel.people.set({
						'$distinct_id': res._id,
						'$first_name': res.firstName,
						'$last_name': res.lastName,
						status: res.status,
						'$email': res.email,
						'$created': res.created_at
					});
					window.tidioChatApi.setVisitorData({
						distinct_id: res._id,
						email: res.email,
						name: `${res.firstName} ${res.lastName}`
					});
				}).catch((err) => {
					this.setState({
						"loading": false,
						"error": 'An error occured, please try again later.'
					});
					console.log('error', err);
				});
		} else {
			console.log('No token found');
		}
	}


	updateUserProfile(value) {
		this.setState({ user: { ...this.state.user, ...value } });
	}

	saveUserProfile() {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/user`, {
			'headers': config.HEADERS(this.state.token),
			'method': "PUT",
			'body': JSON.stringify(this.state.user)
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				if (res.status === 200) {
					return res.json();
				}
				throw res;
			})
			.then((res) => {
				console.log('put json res', res);
				this.setState({
					loading: false,
					user: res,
					globalMessage: 'Profile updated.'
				});
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error saving profile, please try again.'
				});
				console.log('error saving user profile', err);
			});
	}

	createAdvertiserCampaign(campaign, done) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/brands/campaigns`, {
			'headers': config.HEADERS(this.state.token),
			'method': "POST",
			'body': JSON.stringify(campaign)
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				return res.json()
			})
			.then((res) => {
				this.setState({
					loading: false,
					campaigns: this.state.campaigns.concat([res])
				}, () => { done() });
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while creating a new campaign. Please try again later.'
				}, () => { done() });
				console.log(err);
			});
	}

	login(username, password) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/login`, {
			headers: config.HEADERS_NOAUTH,
			method: 'POST',
			body: JSON.stringify({ username, password })
		}).then((res) => res.json())
			.then((res) => {
				console.log(res);
				if (res.token) {
					localStorage.setItem('token', res.token);
					return this.setState({
						token: res.token,
						loading: false
					});
				}
				throw 'Invalid email or password. Please try again.'
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Invalid email or password. Please try again.'
				});
				console.log(err);
			});
	}

	getAdvertiserCampaigns() {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/brands/campaigns`, {
			headers: config.HEADERS(this.state.token),
			method: "GET",
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				return res.json()
			})
			.then((res) => {
				this.setState({
					loading: false,
					campaigns: res
				});
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while trying to get campaigns. Please try again later.'
				});
				console.log(err);
			});
	}

	updateAdvertiserCampaignPost(campaignId, postId, updateQuery) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/brands/campaigns/${campaignId}/posts/${postId}`, {
			'headers': config.HEADERS(this.state.token),
			'method': "PATCH",
			'body': JSON.stringify(updateQuery)
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				return res.json()
			})
			.then((res) => {
				let newCampaigns = this.state.campaigns.filter(c => c._id !== res._id);
				newCampaigns.push(res);

				this.setState({
					loading: false,
					campaigns: newCampaigns
				});
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while updating a campaign. Please try again later.'
				});
				console.log(err);
			});
	}

	updateAdvertiserCampaign(campaignId, updateQuery) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/brands/campaigns/${campaignId}`, {
			'headers': config.HEADERS(this.state.token),
			'method': "PATCH",
			'body': JSON.stringify(updateQuery)
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				return res.json()
			})
			.then((res) => {
				let newCampaigns = this.state.campaigns.filter(c => c._id !== res._id);
				newCampaigns.push(res);

				this.setState({
					loading: false,
					campaigns: newCampaigns
				});
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while updating a campaign. Please try again later.'
				});
				console.log(err);
			});
	}

	addStripeSource(source, done) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/user/payment-methods`, {
			'headers': config.HEADERS(this.state.token),
			'method': "POST",
			'body': JSON.stringify({ source: source })
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				if (res.status === 200) {
					return res.json();
				}
				throw res;
			})
			.then((res) => {
				this.setState({
					loading: false,
					user: res
				}, () => { done(); });
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while adding a card, please try again later.'
				}, () => { done(); });
				console.log(err);
			});
	}

	approveAdvertiserCampaignPosts(campaignId, done) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/brands/campaigns/${campaignId}/posts`, {
			'headers': config.HEADERS(this.state.token),
			'method': "PATCH",
			'body': JSON.stringify({ action: 'approve' })
		})
			.then((res) => {
				if (res.status === 403) {
					this.logout();
				}
				if (res.status === 200) {
					return res.json();
				}
				throw res;
			})
			.then((res) => {
				let newCampaigns = this.state.campaigns.filter(c => c._id !== res._id);
				newCampaigns.push(res);

				this.setState({
					loading: false,
					campaigns: newCampaigns
				}, () => { done(null); });
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while approving campaign posts.'
				}, () => { done(err); });
				console.log(err);
			});
	}

	getAdvertiserCampaignsMagicLink(magicLink, done) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/ac/${magicLink}`)
			.then((res) => {
				if (res.status === 200) {
					return res.json();
				}
				throw res;
			})
			.then((res) => {
				this.setState({
					loading: false
				}, () => { done(null, res); });
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while trying to get campaign details for magic link.'
				}, () => { done(err); });
				console.log(err);
			});
	}

	patchAdvertiserCampaignsMagicLink(magicLink, statusChanges, done) {
		this.setState({
			loading: true,
			error: null
		});

		fetch(`${config.URL}/ac/${magicLink}`, {
			'headers': config.HEADERS_NOAUTH,
			'method': "PATCH",
			'body': JSON.stringify({
				statusChanges
			})
		})
			.then((res) => {
				if (res.status === 200) {
					return res.json();
				}
				throw res;
			})
			.then((res) => {
				this.setState({
					loading: false
				}, () => { done(null, res); });
			}).catch((err) => {
				this.setState({
					loading: false,
					error: 'Error while trying to patch campaign influencers via magic link.'
				}, () => { done(err); });
				console.log(err);
			});
	}

	render() {
		return (
			<Context.Provider value={{
				"state": this.state,
				"actions": this.actions
			}}>
				{this.props.children}
			</Context.Provider>
		);
	}
}

